import { render, staticRenderFns } from "./WorkbookEntry.modal.vue?vue&type=template&id=bee8ea48&"
import script from "./WorkbookEntry.modal.vue?vue&type=script&lang=ts&"
export * from "./WorkbookEntry.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports